import type { Delegatee } from "@certa/queries/queries/massDelegation/massDelegation.query";
import type { UserData } from "@certa/common/utils/userStorage";

type DelegateAccessItem = {
  id?: number;
  name?: string;
};

type CommonUserAccess = {
  groups: DelegateAccessItem[];
  regionFullAccess: DelegateAccessItem[];
  regionReadAccess: DelegateAccessItem[];
  businessUnitFullAccess: DelegateAccessItem[];
  businessUnitReadAccess: DelegateAccessItem[];
};

export const getCommonDelegationUserAccess = (
  currentUser?: Partial<UserData> | null,
  delegatedUser?: Delegatee["results"][number]
): CommonUserAccess => {
  if (!currentUser || !delegatedUser) {
    return {
      groups: [],
      regionFullAccess: [],
      regionReadAccess: [],
      businessUnitFullAccess: [],
      businessUnitReadAccess: []
    };
  }

  return {
    groups: delegatedUser.groups.filter(group =>
      currentUser.groups?.some(currentGroup => currentGroup.id === group.id)
    ),

    regionFullAccess: delegatedUser.profile?.regionFullAccess.filter(region =>
      currentUser.profile?.region_full_access.some(
        currentRegion => currentRegion === region.id
      )
    ),
    regionReadAccess: delegatedUser.profile?.regionReadAccess.filter(region =>
      currentUser.profile?.region_read_access.some(
        currentRegion => currentRegion === region.id
      )
    ),

    businessUnitFullAccess:
      delegatedUser.profile?.businessUnitFullAccess.filter(businessUnit =>
        currentUser.profile?.business_unit_full_access.some(
          currentBusinessUnit => currentBusinessUnit === businessUnit.id
        )
      ),
    businessUnitReadAccess:
      delegatedUser.profile?.businessUnitReadAccess.filter(businessUnit =>
        currentUser.profile?.business_unit_read_access.some(
          currentBusinessUnit => currentBusinessUnit === businessUnit.id
        )
      )
  };
};
